var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "base-page-header base-page-header__actions d-flex align-center"
    },
    [
      _vm._t("filter-prepend"),
      _vm._t("filter", [
        _vm.hasFilters
          ? _c("BaseFilterMenu", {
              attrs: {
                filters: _vm.filters,
                "filter-button-label": _vm.filterButtonLabel,
                "menu-title": _vm.menuTitle,
                "filter-icon": _vm.filterIcon,
                "menu-width": _vm.menuWidth
              },
              on: { apply: _vm.onFilterApply, clear: _vm.onFilterClear },
              scopedSlots: _vm._u(
                [
                  _vm._l(_vm.$scopedSlots, function(_, slotName) {
                    return {
                      key: slotName,
                      fn: function(slotProps) {
                        return [_vm._t(slotName, null, null, slotProps || {})]
                      }
                    }
                  })
                ],
                null,
                true
              )
            })
          : _vm._e()
      ]),
      _vm._t("actions")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }